export const routes = Object.freeze({
  home: "/",
  notFound: "/not-found",
  games: "/games",
  game: "/game",
  providers: "/providers",
  provider: "/provider",
  favorites: "/favorites",
  profile: "/profile",
  profileEdit: "/profile/edit",
  profileHistory: "/profile/history",
  profileVerification: "/profile/verification",
} as const);

export const publicRoutes: string[] = [routes.home, routes.notFound];

export const knownRoutes: string[] = [...Object.values(routes)];

export const PRIVATE_DEFAULT_ROUTE = "";

export const PUBLIC_DEFAULT_ROUTE = routes.home;
